import React from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import { currencyFormatter } from "@utils";
import { getSellCardsTotals, getSellCardsArray } from "@modules/Sell/selector";
import SellOrderSellButton from "./SellOrderSellButton";
import loadable from "@loadable/component";
import Resizer from "@hocs/Resizer";
const SellOrderSummaryDesktop = loadable(() =>
  import(
    /* webpackChunkName: "SellOrderSummaryDesktop" */ "./SellOrderSummaryDesktop"
  )
);

const SellOrderMainContainer = styled.div`
  @media (max-height: 700px) {
    display: none;
  }

  border-radius: 10px;
  border: solid 1px rgba(119, 121, 132, 0.15);

  @media (min-height: 700px) and (max-width: 950px) {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 2;
    background-color: #ffffff;
    border-radius: 0px;
    border: none;
    border-top: 1px solid rgba(119, 121, 132, 0.1);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }
`;

const InnerContainer = styled.div`
  width: 82%;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 35px;

  @media (max-width: 950px) {
    width: 92%;
    padding-top: 11px;
    padding-bottom: 22px;
  }
  @media (max-width: 850px) {
    width: 85%;
  }
  @media (max-width: 728px) {
    width: 90%;
  }

  @media (max-height: 730px) {
    padding-top: 0px;
    padding-bottom: 12px;
  }
`;

const Offer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 20px;
  margin-bottom: 20px;

  @media (max-width: 950px) {
    margin-top: 15px;
    margin-bottom: 12px;
  }

  @media (max-height: 730px) {
    margin-top: 12px;
    margin-bottom: 7px;
  }
  @media (max-height: 575px) {
    margin-top: 5px;
    margin-bottom: 3px;
  }
`;

const OfferText = styled.div`
  font-size: 16px;
  color: #777984;

  @media (max-height: 730px) {
    font-size: 15px;
  }
  @media (max-height: 575px) {
    font-size: 13px;
  }
`;

const OfferAmount = styled.div`
  font-size: 16px;
  color: #1f2021;
  justify-self: flex-end;

  @media (max-height: 730px) {
    font-size: 15px;
  }
  @media (max-height: 575px) {
    font-size: 13px;
  }
`;

const SellOrderSummary = ({
  orderInfo,
  valid,
  reduxFormDispatch,
  sellCardArray,
  img,
  missingInfo
}) => {
  return (
    <SellOrderMainContainer>
      <InnerContainer>
        <Resizer
          components={[
            {
              component: () => (
                <SellOrderSummaryDesktop sellCardArray={sellCardArray} />
              ),
              break: 950,
              maxBreak: Number.MAX_SAFE_INTEGER
            }
          ]}
        />
        <Offer>
          <OfferText>Your offer</OfferText>
          <OfferAmount>{currencyFormatter(orderInfo.total)}</OfferAmount>
        </Offer>
        <SellOrderSellButton
          reduxFormDispatch={reduxFormDispatch}
          valid={valid}
          paypalButtonClass={"paypal-sell-btn-top"}
          img={img}
          missingInfo={missingInfo}
        />
      </InnerContainer>
    </SellOrderMainContainer>
  );
};

export default connect(state => ({
  payoutType: state.cartSell.payoutType,
  payoutMethod: state.cartSell.payoutMethod,
  checkout: state.checkout,
  orderInfo: getSellCardsTotals({
    cart: state.cartSell,
    cards: state.cards
  }),
  sellCardArray: getSellCardsArray({
    merchants: state.merchantsSell,
    cards: state.cards,
    trade: state.cartSell.tradeBonus
  })
}))(SellOrderSummary);
